<template>
  <div v-if="isAuthorized">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'VAuth',
    props: {
      authorizedRoles: Array,
    },
    computed: {
      ...mapState('auth', ['root', 'userRoles']),

      isAuthorized() {
        if (this.root) {
          return true;
        }
        return this.authorizedRoles.some(r => this.userRoles.includes(r));
      },
    },
  };
</script>
